

import React from 'react';
import ServiceForm from '../components/ServiceForm';
import { CodeHighlighter } from '../components/CodeHighlighter';
// import { CodeHighlighter } from '../components/CodeHighlighter';


const serviceEndpoint = "season/%sid/idp/assessments/fill";

const serviceArguments = []

const serviceUrlArguments = [
  { name: 'sid', type: 'numeric',  mandatory: true, default: '', description: 'Season ID'},
]

const serviceSample = {
  'assessment_id': 1,
  'evaluation_text': '',
  'AT1': 3,
  'AT2': 4,
  'AT3': 6,
  'AT4': 'test',
  'yc_client_timezone': 'Europe/Rome'
}


export function IDPAssessmentSubmit() {
  return <IDPAssessmentSubmitComponent/>;
}


class IDPAssessmentSubmitComponent extends React.Component {

  render() {

        return (
            <div>
                  <h3>Individual Development Plan Assessment Fill</h3>

                  <p>Endpoint: <b>{serviceEndpoint}</b></p>

                  <p>
                    This service can be used to fill an individual development plan assessment.<br/>
                    This service can be invoked only by a player.<br/>
                    In order to be successfully fill an assessment, the assessment itself has the following requirements:<br/>
                    1. The assessment must by assessment_type = 1;<br/>
                    2. The assessment "submitted_by_player_on" field must be null or empty;<br/>
                    3. The assessment should not have an assessment_date in the future (12 hours are granted from the current server time);<br/>
                    <br/>
                    <b>yc_client_timezone</b><br/>
                    Since the server set the timestamp once the report is submitted, the client should send the field <code>yc_client_timezone</code>
                    in order to ensore the correct time in the user's timezone. While this is not an issue in Italy, it is in different timezones such as US.<br/>
                    The timezone is expected to be in to be like 'Europe/Rome'.<br/>
                    In JavaScript, the timezone can be obtained with: <br/>
                    <code>Intl.DateTimeFormat().resolvedOptions().timeZone</code><br/>
                    In React-native, you can use the library <b>react-native-localize</b> to get the timezone:<br/>
                    <code>import * as Localization from 'react-native-localize';</code><br/>
                    <code>const timezone = Localization.getTimeZone();</code><br/>
                    <br/>
                    <b>Instructions for the user</b><br/>
                    The field content contains notes that the coach provides to the player as instructions or suggestions when filling the assessment
                    and may be presented in the context of the assessment form.
                    <br/>
                    <b>evaluation_text</b><br/>
                    The field evaluation_text should be filled only if the assessment has no questions, which is when the template is FALSE.
                    <br/>
                  </p>

                  <b>Types of questions</b>
                  <table className="table table-striped table-bordered table-hover">
                    <thead><tr>
                      <th>Type</th>
                      <th>Description</th>
                    </tr></thead>
                    <tbody>
                      <tr><td>1-3</td><td>From 1 to 3</td></tr>
                      <tr><td>1-4</td><td>From 1 to 4</td></tr>
                      <tr><td>1-5</td><td>From 1 to 5</td></tr>
                      <tr><td>1-6</td><td>From 1 to 6</td></tr>
                      <tr><td>1-7</td><td>From 1 to 7</td></tr>
                      <tr><td>1-8</td><td>From 1 to 8</td></tr>
                      <tr><td>1-9</td><td>From 1 to 9</td></tr>
                      <tr><td>1-10</td><td>From 1 to 10</td></tr>
                      <tr><td>1-10_half_step</td><td>From 1 to 10 (with halfs)</td></tr>
                      <tr><td>percentage</td><td>Percentage (from 1% to 100%)</td></tr>
                      <tr><td>numeric</td><td>Numeric value</td></tr>
                      <tr><td>scale_votes_2</td><td>From Poor to Excellent</td></tr>
                      <tr><td>scale_votes_1</td><td>From Not sufficient to Very Good</td></tr>
                      <tr><td>average</td><td>Above/Under Average</td></tr>
                      <tr><td>yes_no</td><td>Yes or No</td></tr>
                      <tr><td>short_text</td><td>Short Text (single line text)</td></tr>
                      <tr><td>free</td><td>Free Text</td></tr>
                      <tr><td>options</td><td>Options List, a specific options array provides the list of possible values.</td></tr>
                    </tbody>
                  </table>
                  

                  <ServiceForm
                        args={serviceArguments}
                        urlArgs={serviceUrlArguments}
                        sample={serviceSample}
                        endpoint={serviceEndpoint}
                        authRequired={true}
                        usePayload={true}
                  />

                  <h4>Request</h4>
                  <p>
                    POST request
                  </p>
                  <h4>Response</h4>
                  <p>
                    The service returns the serialized version of the assessment or a list of errors indexed by field.
                    <CodeHighlighter code={{
                        "errors": {
                          "AT4": "Invalid value"
                        }
                      }}/>
                  </p>
                  
            </div>
        );
  }


} 


